module.exports = __webpack_public_path__ + "static/img/13.f1f01ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/sp/13.png
// module id = LNu7
// module chunks = 0